import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import Button from "@mui/material/Button";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const useStyles = makeStyles(theme => ({
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 60,
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: "white",
    backgroundColor: "white",
    color: theme.palette.primary.main,
    padding: theme.spacing(2),
  },

  leftContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },

  rightContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },

  back: {
    display: "flex",
    alignItems: "center",
  },

  backButton: {
    padding: 0,
  },

  save: {
    display: "flex",
    alignItems: "center",
  },
}));

const EditBar = props => {
  const { onBackClick, onSaveClick, saveDisabled } = props;
  const classes = useStyles();

  return (
    <div className={classes.toolbar}>
      <div className={classes.leftContainer}>
        <div className={classes.back}>
          <Button
            classes={{
              root: classes.backButton,
            }}
            variant={"text"}
            startIcon={<ChevronLeftIcon />}
            onClick={onBackClick}
          >
            Back
          </Button>
        </div>
      </div>

      <div className={classes.rightContainer}>
        <div className={classes.save}>
          <Button
            variant="contained"
            onClick={onSaveClick}
            disabled={saveDisabled}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditBar;
